import { AuthUser } from '@core/services/auth/auth.interface';

/**
 * Gets the user traits from local storage
 *
 * @returns AuthUser object | null
 */
export const getUserTraits = (): AuthUser | null => {
    if (typeof window === 'undefined') return null;

    const userTraits = localStorage.getItem('ntv_user_traits');

    const parsedUserTraits: AuthUser | null = userTraits ? JSON.parse(userTraits) : null;

    return parsedUserTraits;
};
